export default {
  id: 27,
  title: 'Target #27 - Lock Up',
  url: 'https://cssbattle.dev/play/27',
  colors: ['#E38F66', '#AA445F', '#F7EC7D'],
  solution:
    '<a a><a b><style>body{background:#e38f66}a{position:fixed;border-radius:50%}a[a]{background:#aa445f;width:200;height:200;top:50;left:100}a[b]{border:30px solid #f7ec7d;border-left-color:transparent;border-right-color:transparent;width:80;height:80;top:80;left:130;transform:rotate(45deg)}</style>',
}
